import { Injectable } from '@angular/core';

import { statusProjetadoNaoProjetado, statusProjetadoProjetado, statusProjetadoGanho, isStatusProjetadoEmNegociacao, isStatusProjetadoPerdido } from '../cliente-analise-mercado-status-projetado';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoStatusProjetadoService {
    /** Retorna o status projetado da análise de mercado de clientes */
    getStatusProjetado(
        // Status Atual
        statusProjetadoAtual: number,
        // Projetado
        quantidadePretendidaProjetada: number,
        pesoProjetadoProjetado: number,
        valorProjetadoProjetado: number,
        // Realizado
        quantidadeRealizada: number,
        pesoRealizado: number,
        valorRealizado: number
    ): number {
        // Setando status atual como Não Projetado quando não informado
        statusProjetadoAtual = statusProjetadoAtual && !isNaN(statusProjetadoAtual) ? Number(statusProjetadoAtual) : statusProjetadoNaoProjetado.id;
        /** Normalizando valores nulos para zero */
        // Projetado
        quantidadePretendidaProjetada = quantidadePretendidaProjetada && !isNaN(quantidadePretendidaProjetada) ? Number(quantidadePretendidaProjetada) : 0;
        pesoProjetadoProjetado = pesoProjetadoProjetado && !isNaN(pesoProjetadoProjetado) ? Number(pesoProjetadoProjetado) : 0;
        valorProjetadoProjetado = valorProjetadoProjetado && !isNaN(valorProjetadoProjetado) ? Number(valorProjetadoProjetado) : 0;
        // Realizado
        quantidadeRealizada = quantidadeRealizada && !isNaN(quantidadeRealizada) ? Number(quantidadeRealizada) : 0;
        pesoRealizado = pesoRealizado && !isNaN(pesoRealizado) ? Number(pesoRealizado) : 0;
        valorRealizado = valorRealizado && !isNaN(valorRealizado) ? Number(valorRealizado) : 0;

        // Ganho => Se possuir quantidade ou peso ou valor realizado
        if (quantidadeRealizada > 0 || pesoRealizado > 0 || valorRealizado > 0) {
            return statusProjetadoGanho.id;
        }

        // Em Negociação ou Perdido => Se o status atual for em negociação ou perdido, então continua com o status atual
        if (isStatusProjetadoEmNegociacao(statusProjetadoAtual) || isStatusProjetadoPerdido(statusProjetadoAtual)) {
            return statusProjetadoAtual;
        }

        // Projetado => Se possuir quantidade ou peso ou valor projetado
        if (quantidadePretendidaProjetada > 0 || pesoProjetadoProjetado > 0 || valorProjetadoProjetado > 0) {
            return statusProjetadoProjetado.id;
        }

        // Não Projetado =>  Se não possuir nem potencial, nem projetado e nem realizado
        return statusProjetadoNaoProjetado.id;
    }
}
